module.exports = __webpack_public_path__ + "img/titlezh.322e7841.png";